import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { extractErrorMessage } from "@/lib/errors";
import type { UseQueryResult } from "@tanstack/react-query";

/**
 * Shows an error toast when a query fails, with deduplication to prevent
 * repeated toasts on re-renders. Resets when the query recovers.
 */
export function useQueryErrorToast(
  query: Pick<UseQueryResult, "isError" | "error">,
  message: string,
) {
  const shownRef = useRef(false);

  useEffect(() => {
    if (query.isError && query.error && !shownRef.current) {
      toast.error(message, {
        description: extractErrorMessage(query.error),
      });
      shownRef.current = true;
    } else if (!query.isError) {
      shownRef.current = false;
    }
  }, [query.isError, query.error, message]);
}
